import React from 'react'
import './blog.css'

// Horizontal scroller highlighting Graduation category posts
const GraduationHighlights = ({ posts = [], onSelect }) => {
  if (!posts.length) return null
  const top = posts.slice(0, 8)
  return (
    <section className='grad-highlights-section' aria-labelledby='grad-highlights-heading'>
      <div className='container'>
        <div className='grad-highlights-header'>
          <h2 id='grad-highlights-heading'><i className='fa fa-graduation-cap'></i> Graduation Highlights</h2>
          <p>Top memorable moments from our recent graduation ceremonies.</p>
        </div>
        <div className='grad-highlights-scroll' role='list'>
          {top.map(post => (
            <button
              key={post.id}
              className='grad-highlight-card'
              onClick={() => onSelect(post)}
              role='listitem'
              aria-label={`Open graduation post: ${post.title}`}
            >
              <div className='ghc-image-wrapper'>
                <img src={post.cover} alt={post.title} loading='lazy' />
                {post.additionalPhotos && (
                  <span className='ghc-photo-count'><i className='fa fa-camera'></i>{post.additionalPhotos.length}</span>
                )}
              </div>
              <div className='ghc-content'>
                <h3 className='ghc-title'>{post.title}</h3>
                <div className='ghc-meta'>
                  <span><i className='fa fa-calendar-alt'></i>{post.date}</span>
                  <span><i className='fa fa-clock'></i>{post.readTime}</span>
                </div>
              </div>
              <span className='ghc-overlay'><i className='fa fa-arrow-right'></i></span>
            </button>
          ))}
        </div>
      </div>
    </section>
  )
}

export default GraduationHighlights
